// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"69a52f46","270":"8206e1d2","285":"28ebcec0","479":"23af09d3","635":"c53caec4","742":"36130c2a","791":"99a5b5fe","891":"91cfce57"}[chunkId] + ".chunk.js";
};